import {
  Button,
  DatePicker,
  Form,
  Input,
  Modal,
  Select,
  Space,
  Table,
  Tooltip,
  Typography,
} from "antd";
import {
  PlusOutlined,
  CloseOutlined,
  ArrowRightOutlined,
  AuditOutlined,
  ExportOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { useCallback, useContext, useEffect, useState } from "react";
import CreatePayroll from "./CreatePayroll";
import axios from "axios";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
import PayrollSummary from "./PayrollSummary";
import * as XLSX from "xlsx";
import PayrollPrint from "./PayrollPrint";

const MerchantPayroll = ({ employeeList }) => {
  const [search, setSearch] = useState("");
  const [currentTab, setCurrentTab] = useState("list");
  const [payrollList, setPayrollList] = useState({ data: [], ready: false });
  const { userData } = useContext(UserInfo);
  const tableLayout = "";
  const scroll = {};
  // const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState(false);
  const [summaryDrawer, setSummaryDrawer] = useState(false);
  const [openFilterByDate, setOpenFilterByDate] = useState(false);
  const [loading, setLoading] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);
  const [isFiltered, setIsFiltered] = useState(false);

  const calculateLateUnder = (late, under, per_mins) => {
    var total = 0;
    var totalLateUnder = parseFloat(late) + parseFloat(under);
    total = totalLateUnder * parseFloat(per_mins);
    return total;
  };

  const columns = [
    {
      title: "Employee",
      align: "center",
      render: (text) => (
        <p style={{ textAlign: "left" }}>
          {text.employeedetails.firstname} {text.employeedetails.lastname}
        </p>
      ),
    },
    {
      title: "Covered Period",
      // dataIndex: "date_from",
      align: "center",
      render: (date) => (
        <p style={{ textAlign: "left" }}>
          {moment.utc(new Date(date.date_from)).format("MMMM DD, YYYY")} -{" "}
          {moment.utc(new Date(date.date_to)).format("MMMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Day(s) Present",
      dataIndex: "present_count",
      align: "center",
      render: (data) => <p style={{ textAlign: "right" }}>{data}</p>,
    },
    // {
    //   title: "Date To",
    //   dataIndex: "date_to",
    //   align: "center",
    //   render: (date) => (
    //     <p style={{ textAlign: "left" }}>
    //       {moment.utc(new Date(date)).format("MMMM DD, YYYY")}
    //     </p>
    //   ),
    // },
    {
      title: "Total Late/Undertime",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {parseFloat(
            calculateLateUnder(text.late_mins, text.under_mins, text.per_mins)
          ).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Total Deductions",
      dataIndex: "total_deductions",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {parseFloat(text).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Total Overtime",
      dataIndex: "total_overtime",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {parseFloat(text !== null ? text : 0).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "Net Pay",
      dataIndex: "gross_salary",
      align: "center",
      render: (text, record) => (
        <p style={{ textAlign: "right" }}>
          {parseFloat(text).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 40,
      render: (text) => (
        <p>
          <Tooltip title="Summary">
            <Button
              type="dashed"
              shape="circle"
              onClick={() => {
                setSelectedData(text);
                setSummaryDrawer(true);
              }}
              icon={<AuditOutlined />}
            />
          </Tooltip>
        </p>
      ),
    },
  ];

  const tableProps = {
    bordered: false,
    // loading,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getPayrollList = useCallback(() => {
    var params = { user_id: userData.data.id };
    axios
      .get("user/merchant/get/payroll-list", { params })
      .then((response) => {
        const data = response.data;
        setPayrollList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getPayrollList();
  }, [getPayrollList]);

  const handleFilter = (values) => {
    var params = {
      date_from: moment(new Date(values.date_from)).format("YYYY-MM-DD"),
      date_to: moment(new Date(values.date_to)).format("YYYY-MM-DD"),
      user_id: userData.data.id,
    };
    setLoading(true);
    axios
      .get("user/merchant/filter/get/payroll-list", { params })
      .then((response) => {
        const data = response.data;
        setPayrollList({ data, ready: true });
        setLoading(false);
        if (data.length > 0) {
          setIsFiltered(true);
        }
        rerunNotif("success", "Filter successful.");
      })
      .catch((error) => {
        console.log("Error: ", error);
        // setLoadings(false);
      });
  };

  const searchable = payrollList.data.filter((data) => {
    return (
      data.employeedetails.firstname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0 ||
      data.employeedetails.lastname
        .toLowerCase()
        .indexOf(search.toLowerCase()) >= 0
    );
  });

  const exportToExcel = () => {
    const selectedColumns = [
      "employeedetails.firstname", // goods
      "employeedetails.lastname", // goods
      "date_from", // goods
      "date_to", // goods
      "present_count", // goods
      // Insert the calculated "Total Late/Undertime" after present_count
      "total_deductions", // goods
      "total_overtime", // goods
      "gross_salary", // goods
      "salary", // goods (Net Pay)
    ];

    // Create custom headers
    const customHeaders = [
      "Employee Firstname",
      "Employee Lastname",
      "Date From",
      "Date To",
      "Present Count",
      "Total Late/Undertime", // Placed after Present Count
      "Total Deductions",
      "Total Overtime",
      "Net Pay",
      "Gross Pay",
    ];

    // Function to calculate late/undertime
    const calculateLateUnder77k = (late, under, per_mins) => {
      const totalLateUnder =
        (parseFloat(late || 0) + parseFloat(under || 0)) *
        parseFloat(per_mins || 0);
      return totalLateUnder;
    };

    // Function to format the float values
    const formatCurrency = (value) => {
      return parseFloat(value || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    };

    // Add columns you want to export
    const filteredData = searchable.map((row) => {
      const filteredRow = {};

      selectedColumns.forEach((column) => {
        const nestedProps = column.split(".");
        let value = row;
        nestedProps.forEach((prop) => {
          if (
            value &&
            typeof value === "object" &&
            value.hasOwnProperty(prop)
          ) {
            value = value[prop];
          } else {
            value = null;
          }
        });

        // Apply number formatting to specific columns
        if (
          [
            "gross_salary",
            "salary",
            "total_overtime",
            "total_deductions",
          ].includes(column)
        ) {
          filteredRow[column] = formatCurrency(value);
        } else {
          filteredRow[column] = value;
        }
      });

      // Calculate "Total Late/Undertime" using late_mins and under_mins, even though they are not in selectedColumns
      const lateMins = row.late_mins || 0;
      const underMins = row.under_mins || 0;
      const perMinsValue = row.per_mins || 1; // Default to 1 if per_mins is not available
      const totalLateUnder = calculateLateUnder77k(
        lateMins,
        underMins,
        perMinsValue
      );

      // Insert "Total Late/Undertime" after "Present Count"
      filteredRow["totalLateUnder"] = formatCurrency(totalLateUnder);

      return filteredRow;
    });

    // Transform filteredData to an array format, placing "Total Late/Undertime" after "Present Count"
    const dataArray = filteredData.map((row) => {
      const rowData = selectedColumns.map((column) => row[column]);
      const presentCountIndex = selectedColumns.indexOf("present_count");

      // Insert "Total Late/Undertime" right after "Present Count"
      rowData.splice(presentCountIndex + 1, 0, row["totalLateUnder"]);

      return rowData;
    });

    // Prepend headers
    const exportData = [customHeaders, ...dataArray];

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    // Append the sheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the Excel file
    XLSX.writeFile(workbook, "digimenu_payroll.xlsx");
  };

  return (
    <>
      {currentTab === "list" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
            }}
          >
            <div style={{ flexGrow: 1 }}>
              <Input
                id="search"
                placeholder="Search employee"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{
                  border: "2px solid #e5e5e5",
                  width: window.innerWidth < 576 ? "100%" : 300,
                }}
                size="large"
              />
            </div>

            <Tooltip title="Filter by date">
              <Button
                type="primary"
                icon={<CalendarOutlined />}
                style={{ marginRight: 5 }}
                onClick={() => setOpenFilterByDate(true)}
              >
                Filter
              </Button>
            </Tooltip>

            {isFiltered && (
              <>
                <Tooltip title="Excel Export">
                  <Button
                    icon={<ExportOutlined />}
                    style={{ marginRight: 5 }}
                    onClick={exportToExcel}
                  >
                    Export
                  </Button>
                </Tooltip>

                <Tooltip title="Excel Export">
                  <Button
                    icon={<ExportOutlined />}
                    style={{ marginRight: 5 }}
                    // onClick={exportToExcel}
                    onClick={() => setCurrentTab("payroll-print")}
                  >
                    Payroll Print
                  </Button>
                </Tooltip>
              </>
            )}

            <Button
              icon={<ArrowRightOutlined />}
              onClick={() => setCurrentTab("form")}
            >
              Add Payroll
            </Button>
          </div>
          <div style={{ overflowX: "auto" }}>
            <Table
              {...tableProps}
              pagination={{
                position: ["bottomCenter"],
              }}
              columns={tableColumns}
              dataSource={searchable.length > 0 ? searchable : []}
              scroll={scroll}
              rowKey={(record) => record.id}
              // rowSelection={rowSelection}
              // size="small"
            />
          </div>
        </>
      )}

      {currentTab === "form" && (
        <>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 5,
              gap: 5,
            }}
          >
            <div style={{ flexGrow: 1 }} />
            <Button
              type="dashed"
              icon={<CloseOutlined />}
              onClick={() => setCurrentTab("list")}
            >
              Close
            </Button>
          </div>
          <CreatePayroll
            employeeList={employeeList}
            close={() => setCurrentTab("list")}
            getPayrollList={() => getPayrollList()}
          />
        </>
      )}

      {currentTab === "payroll-print" && (
        <PayrollPrint
          payrollList={payrollList}
          close={() => {
            setCurrentTab("list");
          }}
        />
      )}

      {summaryDrawer && (
        <PayrollSummary
          open={summaryDrawer}
          close={() => setSummaryDrawer(false)}
          // rerun={() => handleGetDeductions()}
          selectedData={selectedData}
        />
      )}

      <Modal
        title=""
        open={openFilterByDate}
        onCancel={() => setOpenFilterByDate(false)}
        footer={null}
        width={350}
        centered
      >
        <Form
          layout="vertical"
          name="payroll-filter"
          initialValues={{ employee: "all" }}
          onFinish={handleFilter}
          autoComplete="off"
        >
          <Space
            direction="vertical"
            style={{ width: "100%", margin: 0, marginTop: 20 }}
          >
            <Form.Item
              name="date_from"
              label="Date From"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="date_to"
              label="Date To"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loading ? "Loading" : "Filter"}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default MerchantPayroll;
